export default __webpack_public_path__ + "static/media/Pilgrim.2a2f533b.png";